import that from '../utilities/translationHelper'

const relationshipTypes = {
	CYCLING: {
		type: 'CYCLING',
		name: that.context.translate('Cycling buddy')
	},
	'REAL-LIFE': {
		type: 'REAL-LIFE',
		name: that.context.translate('Friend in real life')
	},
	ONLINE: {
		type: 'ONLINE',
		name: that.context.translate('Online friend')
	}
}

export default relationshipTypes



// WEBPACK FOOTER //
// ./src/enums/relationshipTypes.js